module.exports = __webpack_public_path__ + "img/floor_f4_01.e709de88.png";